module.exports = __webpack_public_path__ + "static/media/icPlayerTrouble.5222424c.svg";